import * as actionTypes from '../../../constants/ActionTypes/Web/Customer/SignUp';

const initialState = {
    'success': false,
    'loading': false,
    'error': false,
    'data': {}
}

const UserSubscriptionInfo = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.FETCH_USER_SUBSCRIPTION_INFO_INIT:
            return {
                ...state,
                loading: true,
                'success': false,
                'error': false,
                'data': {}
            }
        case actionTypes.FETCH_USER_SUBSCRIPTION_INFO_SUCCESS:
            return {
                ...state,
                success: true,
                loading: false,
                data: action.subscriptionResponse,
                'error': false
            }
        case actionTypes.FETCH_USER_SUBSCRIPTION_INFO_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.message,
                'data': {}
            }
        default:
            return {...state};
    }

}

export default UserSubscriptionInfo;